/**
 * VERSIONE LIBRERIA 3
 */


/**
 * struttura Configurazione modelli parte client
 * modello :{
 * 		azione(search,detail,list,csv,view)
 * 		search : { 
 * 			fields : {
 * 				nome : operatore search
 * 			}
 * 		}
 * 
 * }
 * 
 * 
 * type dei campi per l'oggetto control type
 * 
 * date_picker			: controllo calendario con il vero campo come input nascosto
 * hidden				: controllo input nascosto
 * select				: controllo select
 * hasmany
 * switchview			: icona circolare verde/rosso a seconda del valore 1 o 0
 * switchlink			: icona circolare clickabile per switchare da 0 a 1 o valore custom chiamando la 
 * 						  funzione ajax set.
 * texthtml				: controllo con associato i tinyMCE per editare testo html
 * text					: solo text html senza nessun controllo associato
 * hasmany_through
 * input				: contollo input text
 * decimal				: controllo con due input uno per la parte intera, e uno per la parte decimale
 * hidden				: controllo hidden
	password 				:'RenderPassword',
	checkbox				:'RenderCheckbox',
	radio					:'RenderCheckbox',
	time					:'RenderTime',
	datetime_select 		:'RenderDateTime',
	date_select				:'RenderDate',
	datetime_picker			:'RenderDateTime',
	date_picker				:'RenderDate',
	textarea				:'RenderTextarea',
	autocomplete			:'RenderAutocomplete',
	foto					:'RenderFoto',
	attachment				:'RenderAttachment',
	video					:'RenderVideo',
	hasmany					:'RenderHasmany',
	hasmany_through 		:'RenderHasmanyThrough',
	carousel				:'RenderCarousel',
	map						:'RenderMap',
	belongsto				:'RenderBelongsto',
    captcha                 :'RenderCaptcha'
 */

var Model_TicketMsg = {
    edit : EditConfs.extend({
        fields: [
            'body',
            'fotos',
        ],

        init: function () {
            this.fields_type.ticket_id = {
                type: 'input',
                inputType: 'hidden'
            };
            this.fields_type.ticket = {
                    type: 'input',
                    inputType: 'hidden'
                };
            this.fields_type.user_id = {
                    type: 'input',
                    inputType: 'hidden'
                };
            this.fields_type.user = {
                    type: 'input',
                    inputType: 'hidden'
                };
            this.fields_type.sent_by = {
                    type: 'input',
                    inputType: 'hidden'
                };
        }
    })
};

var Model_Ticket = {
    search: SearchConfs.extend({
        fields: [
            'email'
        ],
        operator: {
            'email': 'like',

        },
    }),

    list : ListConfs.extend({
        init: function () {

                this.fields_type.created_at = {type: 'date',format:'numeric-time'};
                this.fields_type.user_id = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.messages = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.status = {type: 'text'};
                this.fields_type.first_msg_fotos = {
                    type: 'hasmany_upload',
                    'uploadType': 'foto',
                };
                this.fields_type.user = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.email = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.name = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.phone = {
                    type: 'input',
                    inputType: 'hidden'
                };
                //updated_by: {'type': 'hidden'},

        },
        fields : [
          'subject',
          'status',
            'contatto_email',
            'contatto',
            'created_at',
            'first_msg_body',
            'first_msg_fotos',
        ],

        actions : ['actionHistory','reply','close'],//['actionView'],
        extra_actions : {
            actionHistory: {

                actionTitle : 'history',
                actionIcon : 'fa fa-history',
                func : function (id) {
                    log.info('conversazione ticket ' + id);
                    document.location.href='/ticket/history/'+id;
                }
            },
            reply : {
                //icon : 'fa-send',
                actionTitle : 'reply',
                actionIcon : 'fa fa-paper-plane-o',
                enabled : function (status) {
                    return status == 'open';
                },
                func : function (id) {
                    log.info('risposta ticket ' + id);
                    document.location.href='/ticket/reply/'+id;
                }
            },
            close : {
                actionTitle : 'close',
                actionIcon : 'fa fa-lock',
                enabled : function (status) {
                    return status == 'open';
                },
                func : function (id) {
                    log.info('chiuso ticket ' + id);
                    var _controller = this._controller;
                    var vKey = this.keyId;
                    var url = "/api/json/set/ticket/status/closed";
                    $.post(Facade.getUrl(url),{id:id},function(json) {
                        if (json.error) {
                            $.errorDialog(json.msg);
                            return ;
                        }
                        _controller.reload(vKey);
                    }).fail(function (e) {
                        log.error(e);
                        $.errorDialog($.getFailMessage(e));
                        return ;
                    })
                    //document.location.href='/ticket/changestate/'+id+'/close';
                }
            },
            reopen : {
                actionIcon : 'fa fa-reload',
                actionText : 're-open',
                enabled : function (status) {
                    return status == 'closed';
                },
                action : function (id) {
                    log.info('riaperto ticket ' + id);
                    var _controller = this;

                    var url = "/api/json/set/ticket/status/open";
                    $.post(Facade.getUrl(url),{id:id},function(json) {
                        if (json.error) {
                            $.errorDialog(json.msg);
                            return ;
                        }
                        _controller.reload();
                    }).fail(function (e) {
                        log.error(e);
                        $.errorDialog($.getFailMessage(e));
                        return ;
                    })
                    //document.location.href='/ticket/changestate/'+id+'/close';
                }
            }
        }



    }),
    edit : EditConfs.extend({
        fields : [
            'subject',
            'status',

            'created_at',
            'first_msg_body',
            'first_msg_fotos',
        ],
        init: function () {
            this.fields_type.first_msg_body = {type: 'texthtml'};
            this.fields_type.user = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.user_id = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.messages = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.contatto = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.contatto_email = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.first_msg_fotos = {
                    type: 'hasmany_upload',
                    'uploadType': 'foto',
                    modelName: 'ticket_msg'
                }
        },
        actions: ['actionSave','actionCancel'],
    })
};

var Model_Faq = {
		listedit : ListConfs.extend({
            init: function () {

				this.fields_type.id = {type:'text'};
				this.fields_type.created_at = {type: 'text'};
                this.fields_type.updated_at = {type: 'text'};
                this.fields_type.descrizione_it = {type: 'texthtml'}
            },
		})
	}

var Model_News = {
        search: SearchConfs.extend({
            fields: ['titolo_it',
                'data'
            ],
            operator : {
                titolo_it : 'like'
            },
            fields_type: {
                'data': {
                    'type': 'date',
                    'dateType' : 'picker'
                }
            },
            layouts: {
            	'titolo_it' : 'custom'
            }
        }),
        list: ListConfs.extend({
            init: function () {

                this.fields_type.data = {
                    type: 'input',
                    inputType: 'hidden'
                }
            },
            fields: [
                'attachments',
                'fotos',
                'titolo_it',
                'data_formatted',
                'attivo'
            ],
        }),
        edit : EditConfs.extend({
            // init: function () {
            //     this.fields_type.tags = {
            //             type: 'hasmany',
            //             'label': 'no'
            //     }
            // },

        	fields : [
                'data',
                'titolo_it',
                'titolo_en',
                'titolo_de',
                'descrizione_it',
                'descrizione_en',
                'descrizione_de',
                'attivo',
                'fotos',
                'attachments'

        	],

        }),
        calendar : CalendarConfs.extend({
        	date_field : 'data',
        	weeks : false, // will hide Saturdays and Sundays
        	header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,agendaWeek,agendaDay'
        	}
        }),
    };

var Model_Log = {
        search : SearchConfs.extend({
            fields: [
                'type'
            ],
            operator : {
                type : 'like'
            }

        }),
        list : ListConfs.extend({
            init: function () {

                this.fields_type.user_id = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.user = {type : 'belongsto', 'fields':['email']};
            },
            fields: [
                'user',
                'type',
                'description',
                'details',
                'ip_address',
                'user_agent',
            ],
        	actions : ['actionView']
        }),
    };

var Model_NewsletterEmail = {
        search : SearchConfs.extend({
            fields: ['email',
                'verified'
            ],
            operator : {
                email : 'like'
            },
            fields_type: {
                'verified':{ type:'select'}
            }
        }),

        list : ListConfs.extend({
            init: function () {
                this.fields_type.user_id = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.user = {type: "belongsto", 'fields':['email']}
            },
        }),
        edit : EditConfs.extend({
            init: function () {
                this.fields_type.user_id = {
                    type: 'input',
                    inputType: 'hidden'
                };
                this.fields_type.user = {type: "belongsto", 'fields':['email']}
            },
        }),

    };

var Model_Pagina = {
        search : SearchConfs.extend({
            fields: ['titolo_it'],
            operator : {
                titolo_it : 'like'
            }
        }),
        list : ListConfs.extend({
            init: function () {

        		this.fields_type.videos = {type: "video"};
        		this.fields_type.menu_item = {type: "belongsto",fields:['nome_it']}
            },
        }),
        edit : EditConfs.extend({
            init: function () {
                this.fields_type.miMenuId = {type: 'select'};
                this.fields_type.miParentId = {type: 'select'};
                this.fields_type.miOrdine = {type: 'select'};
                this.fields_type.menu_item_id  = {
                    type: 'input',
                    inputType: 'hidden'
                }
            },
            connected_fields: {
                miParentId: {
                    sources: ['miMenuId','menu_item_id'],//{'miMenuId':'id'},
                    action: {'name': 'listing', params: {'0_ITEM_NONE': 1}},
                    code: function (event, jQE, json) {
                        console.log(json);
                        try {
                            if (json.error) {
                                $.errorDialog(json.msg);
                                return;
                            }
                            var selectedVal = $(this).val();//$($.find('[name="miParentId"]')[0]).val();
                            $(this).html("");

                            for (var i in json.result) {
                                var selected = '';
                                if (json.result[i].key === selectedVal) {
                                    selected = ' selected="selected"';
                                }
                                $(this).append("<option value='" + json.result[i].key + "'" + selected + ">" + json.result[i].value + "</option>");
                            }
                        } catch (e) {
                            $.errorDialog(e.message);
                        }

                    }
                }
            }
        }),
    };

var Model_User = {
    list : ListConfs.extend({
        init: function () {
            this.fields_type.newsletter_registered = {type : 'swap'};
            this.fields_type.roles = {
                type: 'hasmany',

                layout: 'column',
                fields: ['id'],
                fields_type: {
                    // se vogliamo dettagliare di piu'
                },
                separator: ' ---> '
            };
            this.fields_type.last_login = {
                type : 'date',
                format : 'numeric-time'
            };
        },
        fields: [
            'email','username',
            'cognome','nome',
            'roles',
            'verified',
            'activated',
            'last_login',
            'newsletter_registered',
            'attachments',
            'fotos',

        ],
        order_fields: {
            'email': 'email', 'username': 'username', 'cognome': 'cognome', 'nome': 'nome'
        },

    }),
    edit : EditConfs.extend({
        init: function () {
            this.fields_type.roles = {
                type: 'input',
                inputType: 'hidden'
            };
            this.fields_type.role = {'type': 'select'};
            this.fields_type.access_roles_exists = {
                type: 'input',
                inputType: 'hidden'
            };
            this.fields_type.password = {'type': 'input', inputType :'password'};
            this.fields_type.password_confirmation = {'type': 'input', inputType : 'password'};
            this.fields_type.logins = {
                type: 'input',
                inputType: 'hidden'
            };
            this.fields_type.last_login = {
                type: 'input',
                inputType: 'hidden'
            };

        },
        actions : ['actionSave','actionBack']
    }),
    search : SearchConfs.extend({
        fields: ['email', 'username',
            'cognome', 'nome'
        ],
        operator : {
            email : 'like',
            username : 'like',
            cognome : 'like',
            nome    : 'like'
        }
    }),
    view: ViewConfs.extend({
        fields_type : {
            verified :  { type: 'swap' },
            activated : { type: 'swap'},
            password :  {
                type: 'input',
                inputType: 'hidden'
            },
            password_confirmation : {
                type: 'input',
                inputType: 'hidden'
            },
            newsletter : {
                type: 'input',
                inputType: 'hidden'
            },
            newsletter_registered : {type : 'swap'},
            roles : {
                type: 'input',
                inputType: 'hidden'
            },
        }
    })
};
var Model_MenuItem = {
        list : ListConfs.extend({
            init: function () {

            },
            order_fields: {'nome': 'nome_it', 'ordine': 'ordine'}
        }),
        edit : EditConfs.extend({

            fields: [
              'nome_it',
              'path',
                'menu_id',
                'parent_id',
                'ordine',
                'attivo',
                'linked',

            ],
            init: function () {

                this.fields_type.menu_id = {type: 'select'};
                this.fields_type.parent_id = {
                    type: 'select',
                    dependencies : {
                        sources : ['menu_id'],
                        func : function (evt,container) {
                            var view = this;
                            console.log("func dependencies",evt,container,this._controller);

                            if (evt.params) {
                                var sConf = {
                                    url : Routes.getUrlInstance('listing',{model:view.modelName}),
                                    query_params : {backParams : view.data.backParams,fieldKey:evt.key,sourceValues:{menu_id:evt.params}},
                                    method : Routes.listing.method,
                                    post_params : {}
                                };
                                view._controller._executeRequest(sConf,function (json) {
                                    if (json.error) {
                                        $.errorDialog(json.msg);
                                        return ;
                                    }
                                    var selectElement = $(container).find('select').first();
                                    var selectedVal = selectElement.val();//$($.find('[name="miParentId"]')[0]).val();
                                    selectElement.html("");
                                    selectElement.append("<option value=''>Nessuno</option>");

                                    //console.log(Object.keys(json.result));
                                    for (var i in json.result) {
                                        var selected = '';
                                        if (json.result[i].key === selectedVal) {
                                            selected = ' selected="selected"';
                                        }
                                        selectElement.append("<option value='" + json.result[i].key + "'" + selected + ">" + json.result[i].value + "</option>");
                                    }
                                })
                                //var confRequest = new Rout
                            }
                        }
                    }
                };
            },
            connected_fields: {
                parent_id: {
                    sources: ['menu_id'],
                    action: {'name': 'listing', params: {'0_ITEM_NONE': 1}},
                    code: function (event, jQE, json) {
                        console.log(json);
                        try {
                            if (json.error) {
                                $.errorDialog(json.msg);
                                return;
                            }
                            var selectedVal = $(this).val();//$($.find('[name="miParentId"]')[0]).val();
                            $(this).html("");
                            //console.log(Object.keys(json.result));
                            for (var i in json.result) {
                                var selected = '';
                                if (json.result[i].key === selectedVal) {
                                    selected = ' selected="selected"';
                                }
                                $(this).append("<option value='" + json.result[i].key + "'" + selected + ">" + json.result[i].value + "</option>");
                            }
                        } catch (e) {
                            $.errorDialog(e.message);
                        }

                    }
                }
            }
        }),
    };
var Model_Menu = {
    	tree : TreeConfs.extend({
    		childrenModelName : {
    			"menu_items" : {
    				fields : ['nome_it','path'],
    				fields_type: {}
    			}

    		}
    	}),
    	list : ListConfs.extend({
            init: function () {
    			this.fields_type.id = { type :'text'};
    			this.fields_type.menu_items = {
    				type :'hasmany',
    				layout : 'column',
    				fields : ['nome_it','path'],
    				fields_type : {
    					// se vogliamo dettagliare di piu'
    				},
    				separator : " ---> "
    			}
            },
    	}),
    	edit : EditConfs.extend({
            init: function () {
	    		this.fields_type.menuItems = {
	    			type : 'hasmany'
	    		}
    		}
    	}),
    };
var Model_Role = {
    search : SearchConfs.extend({
        fields : ['name'],
        fields_type : {
            "name" : {
                type : 'input',
                operator : 'like'
            }
        }
    }),
    list : ListConfs.extend({
        fields_type : {
            permissions : {
                type : 'hasmany',
                fields : ['id','route']
            }
        }
    }),
    tree : TreeConfs.extend({
        childrenModelName : {
            "permissions" : {
                fields : ['name','route'],
                fields_type: {},
                multiple : true
            }

        }
    })
};

var Model_CsvmodelComuneIstat = {
	list : ListConfs.extend({
        init: function () {

        },
		errors_cb : { // callback associate agli errori nei campi

		}
	}),
};

var Model_Newsletter = {
    	list : ListConfs.extend({
            init: function () {
    			this.fields_type.sends = {
                    type : 'hasmany',
    				fields : ['created_at','type','status'],
    				layout : 'column',
    				empty_text : 'never_send'   // ci va la chiave in lingua
    			};

            },
            actions : ['actionInsert','actionDelete','actionEdit','actionSend'],
            extra_actions : {
                actionSend : actionSend
            }
            /*
    		extra_actions : {
    			send : {
                	 //icon : 'fa-send',
                	 text : 'Spedisci',
                	 action : function (id,subject_it) {
                		 log.info('spedisco newsletter ' + id + " : " + subject_it);
                		 var tpl_values = {
                				 subject_it:subject_it,
                				 sends_type :{'all':'all','users':'users','newsletter_email':'newsletter_email'}
                		 };

                		 $.renderJson('#sendnewsletter_dialog','#sendnewsletter_dialog',tpl_values);
                		 $('#sendnewsletter_dialog').modal('show').ok(function () {
                		var type = $('#sendnewsletter_dialog select[name="type"]').val();

                			 $.get('/queue/add/newsletter/send',{newsletter_id:id,type:type},function (json) {
                				 if (json.error) {
                					 $.errorDialog(json.msg);
                					 return;
                				 }

                			 }).fail(function (e) {
                				 $.errorDialog($.getFailMessage(e));
                			 });
                		 });
                	 }
                 }
    		}*/


    	}),
    	edit : EditConfs.extend({
            init: function () {
    			this.fields_type.body_it = { 'type' : 'texthtml'};
                this.fields_type.sends = {
                    type: 'input',
                    inputType: 'hidden'
                };
    		},
            actions : ['actionSave','actionSendAll','actionSendUsers','actionCancel'],
            extra_actions : {
                actionSendAll:actionSendAll,
                actionSendUsers:actionSendUsers
            }
            /*
    		extra_actions : {
    			send_all : {
                	 icon : 'fa-send',
                	 text : 'Salva e Spedisci a tutti',
                	 action : function (id,subject_it) {
                		 var _controller = this; // oggetto chiamante qui sempre il controller
                		 $.progressDialog("Salvataggio in corso...", 1);
                		 _controller._save(function (json) {
                			 if (json.error) {
                				 $.errorDialog(json.msg);
                				 return ;
                			 }
                			 $.progressDialog("Invio newsletter ...", 50);
                			 $.get('/queue/add/newsletter/send',{newsletter_id:id,type:'all'},function (json) {
                				 if (json.error) {
                					 $.errorDialog(json.msg);
                					 return;
                				 }
                				 $.progressDialogClose();
                				 $.messageDialog("Salvataggio e invio avvenuto con successo");
                			 }).fail(function (e) {
                				 $.progressDialogClose();
                				 $.errorDialog($.getFailMessage(e));
                			 })
                		 });

                	 }
                 },
                 send_users : {
                	 icon : 'fa-send',
                	 text : 'Salva e Spedisci agli utenti',
                	 action : function (id,subject_it) {
                		 alert('id ' + id);
                	 }
                 }
    		}*/
    	}),
    };
var Model_Visite = {
        csv: CsvConfs.extend({
            fields: [],
            fields_type: {}
        })
    };
var Model_ComuneIstat = {
        csv: CsvConfs.extend({
    		iszip : true,
    		fields: ['utente'],
    		fields_type:{
    			'utente' : {
                    type : 'input'
    			}
    		}
    	})
    };

